import React from 'react';
import { bool, string } from 'prop-types';

import SkeletonBase from './SkeletonBase';
import Classes from './Skeleton.scss';

const CircleSkeleton = ({ withAnimation, size }) => (
  <SkeletonBase className={Classes.CircleSkeleton} width={size} height={size} withAnimation={withAnimation} />
);

CircleSkeleton.propTypes = {
  withAnimation: bool,
  size: string.isRequired,
};

export default CircleSkeleton;
